/** Тексты окна: Отзыв игрока. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.feedback.title": "Write to us",
  "win.feedback.bug": "Bug",
  "win.feedback.idea": "Idea",
  "win.feedback.other": "Other",
  "win.feedback.hintBug": "What happened, and what were you doing?",
  "win.feedback.hintIdea": "What would you add or change?",
  "win.feedback.hintOther": "Say it however you like",
  "win.feedback.contact": "Telegram or email, if you want a reply",
  "win.feedback.note": "We'll add your wave and device ourselves",
  "win.feedback.send": "Send",
  "win.feedback.later": "Not now",
  "win.feedback.doneTitle": "Got it",
  "win.feedback.doneThanks": "Thanks!",
  "win.feedback.doneText": "We read every one ourselves. Left a contact? We'll reply.",
  "win.feedback.doneClose": "Back to battle",
  "win.feedback.errorFailed": "Didn't send. Your text is still here, try again.",
  "win.feedback.errorLimit": "That's a lot for one hour. Try again a bit later.",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.feedback.title": "Написать нам",
  "win.feedback.bug": "Баг",
  "win.feedback.idea": "Идея",
  "win.feedback.other": "Другое",
  "win.feedback.hintBug": "Что случилось и что ты делал перед этим?",
  "win.feedback.hintIdea": "Что бы ты добавил или поменял?",
  "win.feedback.hintOther": "Пиши как есть",
  "win.feedback.contact": "Telegram или почта, если ждёшь ответ",
  "win.feedback.note": "Волну и устройство подставим сами",
  "win.feedback.send": "Отправить",
  "win.feedback.later": "Не сейчас",
  "win.feedback.doneTitle": "Дошло",
  "win.feedback.doneThanks": "Спасибо!",
  "win.feedback.doneText": "Читаем всё сами. Оставил контакт — ответим.",
  "win.feedback.doneClose": "В бой",
  "win.feedback.errorFailed": "Не отправилось. Текст на месте, попробуй ещё раз.",
  "win.feedback.errorLimit": "Многовато за час. Попробуй чуть позже.",
};

const uk: Record<Key, string> = {
  "win.feedback.title": "Написати нам",
  "win.feedback.bug": "Баг",
  "win.feedback.idea": "Ідея",
  "win.feedback.other": "Інше",
  "win.feedback.hintBug": "Що сталося і що ти робив перед цим?",
  "win.feedback.hintIdea": "Що б ти додав або змінив?",
  "win.feedback.hintOther": "Пиши як є",
  "win.feedback.contact": "Telegram або пошта, якщо чекаєш на відповідь",
  "win.feedback.note": "Хвилю й пристрій підставимо самі",
  "win.feedback.send": "Надіслати",
  "win.feedback.later": "Не зараз",
  "win.feedback.doneTitle": "Дійшло",
  "win.feedback.doneThanks": "Дякуємо!",
  "win.feedback.doneText": "Читаємо все самі. Залишив контакт — відповімо.",
  "win.feedback.doneClose": "До бою",
  "win.feedback.errorFailed": "Не надіслалося. Текст на місці, спробуй ще раз.",
  "win.feedback.errorLimit": "Забагато за годину. Спробуй трохи пізніше.",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
